const background = [
    //require : chuyển đổi đường dẫn cho phù hợp
    //thay thế cho import
    {
        id: 0,
        path: require('~/assets/background/backroundThemes/0.svg').default,
    },
    {
        id: 1,
        path: require('~/assets/background/backroundThemes/1.jpg'),
    },
    {
        id: 2,
        path: require('~/assets/background/backroundThemes/2.jpg'),
    },
    {
        id: 3,
        path: require('~/assets/background/backroundThemes/3.jpg'),
    },
    {
        id: 4,
        path: require('~/assets/background/backroundThemes/4.jpg'),
    },
    {
        id: 5,
        path: require('~/assets/background/backroundThemes/5.jpg'),
    },
    {
        id: 6,
        path: require('~/assets/background/backroundThemes/6.jpg'),
    },
    {
        id: 7,
        path: require('~/assets/background/backroundThemes/7.jpg'),
    },
    {
        id: 8,
        path: require('~/assets/background/backroundThemes/8.jpg'),
    },
];

export default background;
